import React from "react";

import Default from "../../assets/contact_default.jpg";
import styles from "./styles.module.scss";

export interface IProps {
  name: string;
  phone: string;
  email: string;
  uri?: string;
}

const ContactHighlight: React.FC<IProps> = (props) => {
  return (
    <div className={styles.container}>
      <img src={props.uri ? props.uri : Default} alt="" />
      <div className={styles.details}>
        <h3>{props.name}</h3>
        <div>
          <p>{props.email}</p>
          <p>{props.phone}</p>
        </div>
      </div>
    </div>
  );
};

export default ContactHighlight;
